import axiosAuth from '../../axiosMain';

async function index() {
  try {
    let response = await axiosAuth.get('/companies');
    return response.data.data;
  } catch (e) {}
}

async function show(id) {
  let response = await axiosAuth.get('/companies/' + id);
  return response.data.data;
}

async function update(id, data) {
  let form = new FormData();
  for (let key in data) {
    if (data[key] !== null) form.append(key, data[key]);
  }
  let response = await axiosAuth.post('/companies/' + id, form);
  return response.data.data;
}

export default {
  index,
  update,
  show,
};
